export const RolePermissions: { [key: string]: string[] } = {
    SvAdmin: [
        // Dashboard
        "Portal.Dashboard",

        // List
        "Portal.List.Admin",
        "Portal.List.SVUser",
        "Portal.List.User",
        "Portal.List.profile",

        // Details
        "Portal.Details.Admin",

        // Register
        "Portal.Register.Admin",
        "Portal.Register.SVUser",
        "Portal.Register.User",
        "Portal.Register.profile",

        // User Manegment
        "Portal.User.Users",

        // Profile Manegment
        "Portal.Profile.Create",
        "Portal.Profile.List",

        // Query Manegment
        "Portal.query.List",

        // Report
        "Portal.Report.Sample-Report",
    ],
    SvUser: [
        // Dashboard
        "Portal.Dashboard",

        // List
        "Portal.List.Admin",
        // "Portal.List.SVUser",
        "Portal.List.User",
        "Portal.List.profile",

        // Details
        "Portal.Details.Admin",

        // Register
        "Portal.Register.Admin",
        // "Portal.Register.SVUser",
        "Portal.Register.User",
        "Portal.Register.profile",

        // User Manegment
        "Portal.User.Users",

        // Profile Manegment
        "Portal.Profile.Create",
        "Portal.Profile.List",


        // Query Manegment
        "Portal.query.List",

        // Report
        "Portal.Report.Sample-Report",
    ],
    Admin: [
        // Dashboard
        "Portal.Dashboard",

        // List
        "Portal.List.User",

        // Details
        "Portal.Details.User",
        "Portal.Details.Profile",

        // Register
        "Portal.Register.User",

        // User Manegment
        "Portal.User.Users",

        // Profile Manegment
        "Portal.Profile.Create",
        "Portal.Profile.List",


        // Query Manegment
        "Portal.query.Create",

        // Report
        "Portal.Report.Sample-Report",
    ],
    User: [
        // Dashboard
        "Portal.Dashboard",

        // List
        "Portal.List.Admin",
        "Portal.List.User",
        "Portal.List.profile",

        // Details
        "Portal.Details.Admin",

        // Register
        "Portal.Register.Admin",
        "Portal.Register.User",
        "Portal.Register.profile",

        // User Manegment
        "Portal.Register.Users",

        // Profile Manegment
        "Portal.Profile.List",

        // Query Manegment
        "Portal.query.Create",

        // Report
        "Portal.Report.Sample-Report",
    ],

    CompanyAdmin: [
        // Dashboard
        "Portal.Dashboard",

        // List
        "Portal.List.Vendor",
        "Portal.List.Season",
        "Portal.List.Healthreport",
        "Portal.List.Price",

        // Details
        "Portal.Details.Vendor",

        // Register
        "Portal.Register.Vendor",

        // Report
        "Portal.Report.Sample-Report",
    ],
    CompanyUser: [

    ],
    VendorAdmin: [

    ],
    VendorUser: [

    ],
    Assayer: [

    ],
};
